import { useStore } from 'zustand';
import { useNavigate } from 'react-router-dom';
import { useUnityBuildStore, defaultProject } from '../../stores/store';
import { useAssemblyStore } from '../../stores/AssemblyStore';
import { useInferenceStore } from '../../stores/inferenceStore';
import { ResetStates } from '../../stores/resetStates';
import { useFetchUser } from '../../hooks/useFetchUsers';
import { UbAccountService } from '../../api/UbAccountService';
import { SettingsProps } from './Settings';
import { useKeyBoardEventStore } from '../../stores/keyEventStore';
import { useLocalStorage } from '../../stores/localStorage';
import { useQueryClient } from 'react-query';

export function useHandleLogOut({ onCloseMenu, onLogout }: SettingsProps) {
  const store = useStore(useUnityBuildStore);
  const store1 = useStore(useAssemblyStore);
  const store3 = useStore(useInferenceStore);
  const setSessionToken = useStore(useLocalStorage).setSessionToken;
  const keyBoardEventStore = useStore(useKeyBoardEventStore);
  const { setIsLoggedIn, setProjectListIsMounted, setSelectedProject } =
    useStore(useUnityBuildStore);
  const navigate = useNavigate();
  const { data: user } = useFetchUser();
  const queryClient = useQueryClient();

  const handleLogOut = async () => {
    try {
      if (user && user.user) {
        // Log out user on backend
        await UbAccountService.logAccountUserInorOut(user.user.id, false);
      }
      ResetStates.resetMasterProjectViewStates(store, store1, store3, keyBoardEventStore);

      // Reset local state
      setIsLoggedIn(false);
      setSessionToken('');
      setSelectedProject(defaultProject);
      setProjectListIsMounted(false);

      // Clear all localStorage data
      localStorage.clear();

      // Reset the sync connector store state
      try {
        const { useSyncConnectorStore } = require('../../hooks/useSyncConnector');
        if (typeof useSyncConnectorStore.setState === 'function') {
          useSyncConnectorStore.setState({ syncMap: {} });
        }
      } catch (e) {
        console.error('Error resetting sync connector store:', e);
      }

      // Clear React Query cache
      queryClient.cancelQueries();
      queryClient.clear();
      queryClient.resetQueries();
      queryClient.removeQueries();

      // Close menus and navigate away
      onCloseMenu();
      onLogout();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return handleLogOut;
}
